// extracted by css-extract-rspack-plugin
export default {"card":"k_wJvDNFvN4HDzjL"};